export { CriterionTypes, AnonymousCriterionTypes, ContentTypes, TargetTypes } from 'smart-content-core/constants';
export const DEFAULT_CRITERION_VALUE = null;
export const SEARCH_DEBOUNCE_WAIT = 300;
export const DragDropItemTypes = Object.freeze({
  CRITERION: 'CRITERION'
});